// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M12.5 3.5L3.5 12.5\" stroke=\"#98A2B3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> <path d=\"M12.5 12.5L3.5 3.5\" stroke=\"#98A2B3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/> </svg> ";
// Exports
module.exports = code;